package org.dronda.app.web.repository

import org.dronda.app.web.repository.util.decodeClaims
import org.dronda.app.web.ui.util.mapState
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
class UserRepository(
    authRepository: AuthRepository
) {
    val userState = authRepository.loginState.mapState { loginState ->
        when (loginState) {
            AuthRepository.State.Empty -> {
                State.NotLoggedIn
            }
            is AuthRepository.State.Loaded -> {
                val claims = decodeClaims(loginState.tokens.token)
                if (claims != null) {
                    State.LoggedIn(Uuid.parseHexDash(claims.clientUuid), claims.clientId)
                } else {
                    State.NotLoggedIn
                }
            }
            AuthRepository.State.Loading -> State.Loading
        }
    }

    val loggedInState: State.LoggedIn?
        get() = (userState.value as? State.LoggedIn)

    sealed interface State {
        object Loading : State
        object NotLoggedIn : State
        @OptIn(ExperimentalUuidApi::class)
        data class LoggedIn(
            val userUuid: Uuid,
            val username: String,
        ) : State
    }
}
